import BaseApp from "../modules/base-app";
import BecomeJobberTitle from "../pages/become-jobber-title";

const BecomeJobberTitleApp = (props) => (
  <BaseApp>
    <BecomeJobberTitle {...props} />
  </BaseApp>
);

export default BecomeJobberTitleApp;
